import {
    DASHBOARD_SCHEDULE_SUMMARY_GET,
    DASHBOARD_SERVICE_REASSIGNMENT_GET,
    MERCHANDISER_DASHBOARD_NOTIFICATIONS_GET,
    MERCHANDISER_DASHBOARD_SERVICES_GET
} from "api/menu/dashboard/actions";

const initialState = {
    scheduleSummary: [],
    serviceReassignment: [],
    merchandiserNotifications: [],
    merchandiserServices: [],
};

export default function (state = initialState, action) {
    switch (action.type) {
        case DASHBOARD_SCHEDULE_SUMMARY_GET:
            return {
                ...state,
                scheduleSummary: action.payload
            };
        case DASHBOARD_SERVICE_REASSIGNMENT_GET:
            return {
                ...state,
                serviceReassignment: action.payload
            };
        case MERCHANDISER_DASHBOARD_NOTIFICATIONS_GET:
            return {
                ...state,
                merchandiserNotifications: action.payload
            };
        case MERCHANDISER_DASHBOARD_SERVICES_GET:
            return {
                ...state,
                merchandiserServices: action.payload
            };
        default:
            return state;
    }
}
